
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  Candidate,
  CandidateResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";

enum cheatEnum {
  "screenshot" = "小程序防截屏检测",
  "mobileJoinCount" = "小程序防切屏检测",
  "replacePerson" = "换人检测",
  "webJump" = "Web防切屏检测",
  "faceDetection" = "露脸检测",
  "faceCheck" = "人脸核验",
  "readingDetection" = "念稿检测"
}

const cheatKeys = [
  "screenshot",
  "mobileJoinCount",
  "replacePerson",
  "webJump",
  "faceDetection",
  "faceCheck",
  "readingDetection"
];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];

//异常项 对应文案 详情用
const errorEnumTextEX = {
  faceCheck: ["候选人未作答", "人脸核验异常", "通过"],
  replacePerson: ["候选人未作答", "换人检测异常", "通过"],
  faceDetection: ["候选人未作答", "露脸检测异常", "通过"],
  webJump: ["未进行防切屏检测", "切屏异常", "通过"],
  screenshot: ["未进行防截屏检测", "截屏异常", "通过"],
  mobileJoinCount: ["未进行防切屏检测", "切屏异常", "通过"],
  readingDetection: ["样本不足无法检测", "念稿检测异常", "通过"]
};

@Component({})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  connectCode = "";
  cheatList: any = [];

  @Watch("all")
  getAll(nval: CandidateResult) {
    this.getCheatList();
  }

  @Watch("pdfIng")
  handlePdfIng(newVal: boolean) {
    this.showMoreImg = newVal;
  }

  created() {
    //
    // this.getCheatList()
  }

  //
  mounted() {
    this.getCheatList();
    // this.connectCode = this.$route.query.connectCode as string;
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }
  showMoreImg = false;

  //是否折叠图片 换人检测
  get showMoreBtn() {
    return (
      this.candidate.replaceCheckResult.imgList.length > 6 &&
      !this.showMoreImg &&
      this.hasReplacePerson
    );
  }

  //展示出的图片 换人检测
  get getImgList() {
    if (this.showMoreBtn) {
      return this.candidate.replaceCheckResult.imgList.slice(0, 6);
    } else {
      return this.candidate.replaceCheckResult.imgList;
    }
  }

  // 是否包含露脸检测且检测过
  get hasFaceDetection() {
    const faceDetection = this.cheatList.filter(
      (el: any) => el.task === "faceDetection"
    );
    return (
      faceDetection.length > 0 &&
      faceDetection[0].type !== 0 &&
      this.candidate.faceDetectionResult.imgList.length > 0
    );
  }

  get hasFaceCheck() {
    const faceCheck = this.cheatList.filter(
      (el: any) => el.task === "faceCheck"
    );
    return faceCheck.length > 0;
  }

  // 是否包含换人检测且检测过
  get hasReplacePerson() {
    const replacePerson = this.cheatList.filter(
      (el: any) => el.task === "replacePerson"
    );
    return replacePerson.length > 0 && replacePerson[0].type !== 0;
  }

  openImg(url: string) {
    this.$emit("openImg", url);
  }

  getCheatList() {
    this.cheatList = [];
    this.all.errorInfoList.forEach(item => {
      if (cheatKeys.includes(item.task)) {
        this.cheatList.push({
          name: cheatEnum[item.task],
          type: item.result,
          task: item.task,
          result: errorEnumText[item.result],
          value:
            item.resMessage ||
            errorEnumTextEX?.[item.task]?.[item.result] ||
            errorEnumText[item.result]
        });
      }
    });
    console.log(this.cheatList);
  }

  async wait(secends: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, secends);
    });
  }
}
